"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEventRequestToJSON = exports.CreateEventRequestFromJSONTyped = exports.CreateEventRequestFromJSON = exports.instanceOfCreateEventRequest = void 0;
var runtime_1 = require("../runtime");
var EventType_1 = require("./EventType");
/**
 * Check if a given object implements the CreateEventRequest interface.
 */
function instanceOfCreateEventRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateEventRequest = instanceOfCreateEventRequest;
function CreateEventRequestFromJSON(json) {
    return CreateEventRequestFromJSONTyped(json, false);
}
exports.CreateEventRequestFromJSON = CreateEventRequestFromJSON;
function CreateEventRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, EventType_1.EventTypeFromJSON)(json['type']),
    };
}
exports.CreateEventRequestFromJSONTyped = CreateEventRequestFromJSONTyped;
function CreateEventRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, EventType_1.EventTypeToJSON)(value.type),
    };
}
exports.CreateEventRequestToJSON = CreateEventRequestToJSON;
